<form [formGroup]="dateForm" *ngIf="entity && dateForm && entity.visibleToUser" novalidate>
  <div class="form-group">
     @if(!templateForPermitForm){
    <wm-de-label [entity]="entity" [for]="entity.templateCode + '-DATE'"></wm-de-label>
     }
    <div class="d-flex align-items-center">
      <div class="mr-2">

           @if(!templateForPermitForm){
                <input
                  *ngIf="entity.canUserEdit"
                  class="form-control"
                  placeholder="mm/dd/yyyy"
                  [name]="entity.templateCode + '-DATE'"
                  [id]="entity.templateCode + '-DATE'"
                  [formControlName]="entity.templateCode + '-DATE'"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  (focus)="onFocus()"
                  (dateSelect)="onDateSelect()"
                  [restoreFocus]="false"
                  [autoClose]="true"
                />
                <input
                  *ngIf="!entity.canUserEdit"
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  [id]="entity.templateCode"
                  [value]="getSafeDisplayDate(entity.editedValue || entity.initialValue)"
                />
            }@else{
              <wm-common-textfield
               *ngIf="entity.canUserEdit"
                [data]="{
                  label: entity.label,
                  placeholder: 'mm/dd/yyyy',
                  type: 'date',
                  required: entity.isRequired,
                  value: getSafeDisplayDate(entity.editedValue || entity.initialValue)
                }"
                [formControlName]="entity.templateCode + '-DATE'"
                (valueChange)="onCommonTextfieldDateChange($event)"

              ></wm-common-textfield>

               <wm-common-textfield
               *ngIf="!entity.canUserEdit"
                [data]="{
                  label: entity.label,
                  value: getSafeDisplayDate(entity.editedValue || entity.initialValue)
                }"

              ></wm-common-textfield>

          }
      </div>
    </div>
  </div>
</form>
